/* Graefer: Handy-Menü – ganze Zeile öffnet das Untermenü (10.10.2026). Zum Deaktivieren die Einbindung in layout/theme.liquid entfernen. */
(function () {
  function isDrawer() {
    var nav = document.getElementById('nav');
    return !!nav && getComputedStyle(nav).position === 'fixed';
  }

  function label() {
    document.querySelectorAll('#nav li.sub > a.toggle-back').forEach(function (b) {
      if (b.textContent.trim() !== 'Zurück') b.textContent = 'Zurück';
    });
    document.querySelectorAll('#nav > ul > li.sub').forEach(function (li) {
      var a = li.querySelector(':scope > a:not(.toggle)');
      if (a && !a.hasAttribute('data-gx-all')) {
        a.setAttribute('data-gx-all', 'Alle ' + a.textContent.trim() + ' ansehen');
      }
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    label(); // das Theme baut das Menü nach dem Laden neu auf
    var a = e.target.closest('#nav > ul > li.sub > a:not(.toggle)');
    if (!a || !isDrawer()) return;
    var li = a.parentElement;
    if (li.classList.contains('toggle')) return; // geöffnetes Untermenü: Kopfzeile führt zur Kategorie
    var t = li.querySelector(':scope > a.toggle:not(.toggle-back)');
    if (!t || t.offsetWidth === 0) return;
    e.preventDefault();
    e.stopPropagation();
    label();
    t.click();
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', label); else label();
})();
